import React from 'react'

const LetsTalk = () => {
    return (
        <section id="lets-talk">
            <div id="lets-talk-wrapper">
                <article>
                    <h1>Let's talk about your project</h1>
                    <p>Leave a request - our managers will analyze your current situation and help you choose a site to scale your business</p>
                    <div className="lets-discuss">
                        <p>let's discuss your project</p>
                        <span className="material-symbols-outlined">
                            arrow_outward
                        </span>
                    </div>
                </article>
            </div>
        </section>
    )
}

export default LetsTalk